export default __webpack_public_path__ + "static/media/product.88cd65e7.svg";